import type { CSSProperties, ReactNode } from 'react';

export type HandKickerProps = {
  size?: number;
  /** Rotation degrees (default -1.5 for organic feel). */
  rot?: number;
  /** Override Caveat color (default magenta `--color-magenta`). */
  color?: string;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

/**
 * Handwritten subhead in Caveat — sits under brand-mark headlines or
 * under PhaseTags as an ink note in the dossier voice. Ships rotated
 * by default so it feels jotted, not typed.
 */
export const HandKicker = ({
  size = 22,
  rot = -1.5,
  color,
  className,
  style,
  children,
}: HandKickerProps) => {
  return (
    <div
      className={['hand', className ?? ''].filter(Boolean).join(' ')}
      style={{
        fontSize: size,
        transform: `rotate(${rot}deg)`,
        display: 'inline-block',
        lineHeight: 1.05,
        ...(color ? { color } : null),
        ...(style ?? {}),
      }}
    >
      {children}
    </div>
  );
};
